import * as types from "./types";
import {
  listTaxcode,
  createTaxcode,
  updateTaxcode,
  deleteTaxcode
} from "@/services/taxcode";

export default {
  async fetchTaxcodeListforTenant({ commit }, payload) {
    try {
      const data = await listTaxcode(payload);
      commit(types.SET_TAXCODELIST, data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  },

  async createTaxcode({ commit }, payload) {
    try {
      const data = await createTaxcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async updateTaxcode({ commit }, payload) {
    try {
      const data = await updateTaxcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },
  async deleteTaxcode({ commit }, payload) {
    try {
      const data = await deleteTaxcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },
  async setTaxcodeObject({ commit }, payload) {
    try {
      commit(types.SET_TAXCODEOBJECT, payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }
};
